export default __webpack_public_path__ + "media/titles/title_2_locale_da-782135ba.png";